import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.acf-block:not(.block-testimonial-cards) .block-testimonials .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		const slides = slider.querySelectorAll('.swiper-slide');
		const pagination =
			slider?.parentElement.querySelector('.swiper-pagination');

		slider.parentElement.classList.add(
			`block-testimonials__swiper--${index}`
		);

		const settings = {
			loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: `.block-testimonials__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-testimonials__swiper--${index} .swiper-button-next`,
			},
		};

		if (pagination) {
			settings.pagination = {
				el: pagination,
				type: 'fraction',
				formatFractionCurrent: (number) =>
					String(number).padStart(2, '0'),
				formatFractionTotal: (number) =>
					String(number).padStart(2, '0'),
				renderFraction: (currentClass, totalClass) => {
					return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
				},
			};
		}

		new Swiper(slider, settings);
	});
}
